import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { memo, useMemo } from 'react';
import { isDark } from '../common/utils';
import styles from './kbd.module.scss';
const Kbd = memo(({ children, size = 'sm', buttonRaised = 'left', thickness = 2 }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const kbdClass = useMemo(() => classNames(styles.wrapper, {
        [styles[`${size}`]]: true,
        [styles[`${buttonRaised}_raised`]]: true,
        [styles.dark]: isDarkMode,
    }), []);
    const style = useMemo(() => ({
        '--rc-kbd-thickness': `${thickness}px`,
    }), []);
    return (_jsx("kbd", { className: kbdClass, style: style, children: children }));
});
Kbd.displayName = 'Kbd';
export { Kbd };
